<template>
  <div
    :class="
      `no-left-pad no-right-pad
          ${medium.type === 'Photo' ? 'main-photo-wrapper' : 'main-video-wrapper'}`
    "
  >
    <div v-if="medium.type === 'Vr'" class="vr-wrap" v-html="medium.script"></div>
    <div v-else-if="medium.type === 'Video'">
      <stock-video :videoId="medium.youtubeMrId"></stock-video>
    </div>
    <div v-else-if="medium.type === 'Photo'" class="main-photo">
      <img :src="mainPhoto" />
    </div>
  </div>
</template>
<script>
import StockVideo from '@/components/StockDetails/StockVideo';
export default {
  components: {
    StockVideo,
  },
  props: ['medium'],
  computed: {
    mainPhoto() {
      return `${this.medium.src}/l.jpeg`;
    },
  },
};
</script>
<style scoped>
.no-left-pad {
  padding-left: 0;
  margin-left: 0;
}
.no-right-pad {
  padding-right: 0;
  margin-right: 0;
}
.main-photo-wrapper {
  flex: 0 1 30%;
  background: #343434;
}

.main-video-wrapper {
  flex: 0 1 50%;
  background: #343434;
}

.main-photo img {
  min-height: 350px;
  width: 100%;
  display: block;
}

.vr-wrap {
  display: flex;
}

.vr-wrap >>> iframe {
  width: 100%;
  aspect-ratio: 16 / 9;
}

@media (max-width: 812px) {
  .vr-wrap >>> iframe {
    height: calc(100vh - 240px);
  }
}
</style>
